import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@utils';

const captionVariants = cva(
  'font-sans text-sm font-medium uppercase tracking-[0.22em] text-secondary',
);

type CaptionElement = 'span' | 'p';

export type CaptionProps = VariantProps<typeof captionVariants> & {
  as?: CaptionElement;
  className?: string;
  children: React.ReactNode;
};

function Caption({ as: Component = 'span', className, children }: CaptionProps) {
  return <Component className={cn(captionVariants(), className)}>{children}</Component>;
}

Caption.displayName = 'Caption';

export { Caption, captionVariants };
